import AppRoute from "models/AppRoute"
import { InvoiceAssignmentStatus } from "models/Invoice"

interface IInvoicesRouteParams {
    InvoiceAssignmentStatus?: InvoiceAssignmentStatus
}

const InvoicesRoute = new AppRoute<IInvoicesRouteParams>({
    route: "/invoices",
    navbar: true,
    authRequired: true,
})

export default InvoicesRoute
